/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.personalization.rpc.PersonalizationRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

/**
 *  Response card model for marketplace assets (themes and modules).
 *  Represents a single asset in search results returned via CHIRP RPC.
 */

/**
 *  Request model for searching marketplace assets (themes and modules) via CHIRP RPC.
 *  Extends AssetQueryFields which provides all the filter and query parameters.
 */

/**
 *  Response model for asset search via CHIRP RPC.
 *  Contains the total count and list of asset cards matching the search criteria.
 */

/**
 *  RPC-compatible filter for theme business types.
 */

/**
 *  RPC-compatible filter for asset offering types (THEME or MODULE).
 */

/**
 *  RPC-compatible filter for theme page features.
 */

/**
 *  RPC-compatible filter for theme page types.
 */

/**
 *  RPC-compatible filter for asset providers (company names).
 */

/**
 *  RPC-compatible filter for asset tags.
 */

export const BooleanFilterQueryTypename = 'com.hubspot.marketplace.search.models.filters.BooleanFilterQuery';
export const ExistsFilterQueryTypename = 'com.hubspot.marketplace.search.models.filters.ExistsFilterQuery';
export const FloatFilterQueryTypename = 'com.hubspot.marketplace.search.models.filters.FloatFilterQuery';
export const LongFilterQueryTypename = 'com.hubspot.marketplace.search.models.filters.LongFilterQuery';

/**
 *  RPC-compatible filter for module categories.
 *  Uses String values (category names) matching the core implementation.
 */

/**
 *  RPC-compatible filter for module content types.
 *  Uses String values (content type names) matching the core implementation.
 */

/**
 *  RPC-compatible filter for asset price range.
 */

export const StringFilterQueryTypename = 'com.hubspot.marketplace.search.models.filters.StringFilterQuery';

/**
 *  RPC-compatible filter for asset tiers. Only supports OR queries.
 */

export const searchRpc = {
  serviceName: 'com.hubspot.marketplace.personalization.rpc.PersonalizationRpc',
  rpcName: 'search',
  auth: 'app',
  fingerprint: 'bkGV_fZRgfKtKHlts8BF4pwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const autocompleteRpc = {
  serviceName: 'com.hubspot.marketplace.personalization.rpc.PersonalizationRpc',
  rpcName: 'autocomplete',
  auth: 'app',
  fingerprint: 'i8dmKg7zF6QQs_hh7tXWr5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSearchFilterDefinitionsRpc = {
  serviceName: 'com.hubspot.marketplace.personalization.rpc.PersonalizationRpc',
  rpcName: 'getSearchFilterDefinitions',
  auth: 'app',
  fingerprint: 'KmIdoIswThFblI0n6gkSc5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSuggestionSectionsRpc = {
  serviceName: 'com.hubspot.marketplace.personalization.rpc.PersonalizationRpc',
  rpcName: 'getSuggestionSections',
  auth: 'app',
  fingerprint: 'ka5BedAKnPU86WpRdozNt5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSuggestionSectionsByTypeRpc = {
  serviceName: 'com.hubspot.marketplace.personalization.rpc.PersonalizationRpc',
  rpcName: 'getSuggestionSectionsByType',
  auth: 'app',
  fingerprint: 'dym6LRuu_mI86WpRdozNt5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const callbackAiResponseRpc = {
  serviceName: 'com.hubspot.marketplace.personalization.rpc.PersonalizationRpc',
  rpcName: 'callbackAiResponse',
  auth: 'app',
  fingerprint: 'O8TNc1n_fZj_NU7vTA2z2pwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const streamAiResponseRpc = {
  serviceName: 'com.hubspot.marketplace.personalization.rpc.PersonalizationRpc',
  rpcName: 'streamAiResponse',
  auth: 'app',
  fingerprint: 'O8TNc1n_fZiFxj_-39CsnpwP6LXzGzX8',
  na1Only: false,
  isStreaming: true,
  isHublessAppAuth: false
};
export const searchAssetsRpc = {
  serviceName: 'com.hubspot.marketplace.personalization.rpc.PersonalizationRpc',
  rpcName: 'searchAssets',
  auth: 'app',
  fingerprint: 'genRUNkvVs6kD5Z6FkgKIJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};